import React from 'react';
// import { colors } from '../../theme/colors';

interface OwnProps extends React.SVGProps<SVGSVGElement> {
	prefix?: string;
	strokeColor?: string;
	fillColor?: string;
}

export const Icon = ({
	name = '',
	prefix = 'icon',
	color,
	strokeColor = 'currentColor',
	fillColor = 'currentColor',
	...props
}: OwnProps) => {
	const symbolId = `#${prefix}-${name}`;

	return (
		<svg {...props} color={color} aria-hidden="true">
			<use
				href={symbolId}
				style={{ fill: fillColor, stroke: strokeColor }}
			/>
		</svg>
	);
};
